// MenuLoader.js
var MenuLoader = pc.createScript('menuLoader');

MenuLoader.attributes.add("button", {type: "entity"});
MenuLoader.attributes.add("marginY", {type: "number"});
MenuLoader.attributes.add('jsonMenu', { type: 'asset', assetType: 'json' });

MenuLoader.prototype.posArray = [];

// initialize code called once per entity
MenuLoader.prototype.initialize = function() {
    console.log('init MenuLoader');
    
    var that = this;
    
    if(this.button) {
        this.button.enabled = false;
    }
    
    
    /*
    this.loadJsonFromRemote("https://dev.ufomammoot.com/playcanvas/menu.json", function (data) {
        for (var i = 0; i < data.menuItems.length; i++) {
            var menuItem = data.menuItems[i];
            var clonedButton = that.button.clone();
            that.createMenuItem(menuItem, clonedButton);
            
        }
    });
    */
    
    this.parseJsonData(this.jsonMenu.resource, that);
    
    this.posArray = [];
};

MenuLoader.prototype.createMenuItem = function (menuItem, clonedButton, i, that, MyEntity) {

    MyEntity.setPosition(1,0, 0);
    MyEntity.setLocalEulerAngles(0,0,i * 25);
    clonedButton.enabled = true;
    clonedButton.script.targetLink.url = menuItem.url;

    
    that.entity.addChild(MyEntity);
    this.posArray.push(MyEntity);
    
};

MenuLoader.prototype.parseJsonData = function (data, that) {
    var menuItems = data.menuItems;
    
    for (var i = 0; i < menuItems.length; i++) {
        var menuItem = data.menuItems[i];
        var clonedButton = that.button.clone();
        var MyEntity = new pc.Entity('Entity Parent' + i);
        MyEntity.addChild(clonedButton);
        that.createMenuItem(menuItem, clonedButton, i, that, MyEntity);
    }
};

MenuLoader.prototype.loadJsonFromRemote = function (url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function () {
        callback(JSON.parse(this.response));
    });
    xhr.open('GET', url);
    xhr.send();
};


